import React from 'react';

export default function TopBar({ setSidebarOpen, user }) {
  return (
    <div className="sticky top-0 z-20 h-16 bg-white border-b border-gray-200 px-4 flex items-center justify-between shadow-sm flex-shrink-0">
      <div className="flex items-center gap-3">
        <button 
          onClick={() => setSidebarOpen(true)} 
          className="lg:hidden p-2 -ml-2 text-gray-500 hover:text-gray-700 rounded-lg focus:bg-gray-100"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
        <h1 className="font-bold text-gray-900 hidden sm:block text-lg">Dispatcher Portal</h1>
      </div>
      
      <div className="flex items-center gap-4">
        <div className="hidden sm:flex flex-col items-end text-sm">
          <span className="font-semibold text-gray-900">{user?.full_name || "Dispatcher"}</span>
          <span className="text-gray-500 text-xs">{user?.company_name || "Operations"}</span>
        </div>
        <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center font-bold text-white shadow-md">
          {user?.full_name?.charAt(0).toUpperCase() || "D"}
        </div>
      </div>
    </div>
  );
}